var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tarifs"}},[_c('img',{attrs:{"src":_vm.optimize(_vm.content.img,_vm.getWidth()),"alt":"Tarifs"}})])}
var staticRenderFns = []

export { render, staticRenderFns }